import { Promise } from 'bluebird';
import { Episode } from './../../types';
import AnchorAPIError from './AnchorAPIError';

const deleteEpisode = (episode: Episode) => {
  return new Promise<any>((resolve, reject) => {
    const { id } = episode;
    switch (id.kind) {
      case 'webId':
        return fetch(`/api/podcastepisode/${id.webId}`, {
          credentials: 'same-origin',
          method: 'DELETE',
        }).then(
          (response: any): void => {
            if (response.ok) {
              // TODO: We should ad runtime checking to verify that the json can be converted to Episode[]
              resolve();
            } else {
              const error = new AnchorAPIError(
                response,
                `Server error: ${response.statusText} (${response.status}) - ${
                  response.url
                }`
              );
              reject(error);
            }
          }
        );
      case 'id':
        return new Error('deleteEpisode: only supports webId');
      default:
        const exhaustiveCheck: never = id;
        return exhaustiveCheck;
    }
  });
};

export { deleteEpisode };
